import { FilterMatchMode } from 'primereact/api';

export const tableFilters = {
  contenedor: { value: null, matchMode: FilterMatchMode.CONTAINS },
  viajeCarga: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tipo: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tamano: { value: null, matchMode: FilterMatchMode.CONTAINS },
};
